const initialState = {
    cartCount: Number(localStorage.getItem('cartCount')) || 0,
  };

const cartCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'cart/setCount':
          localStorage.setItem('cartCount', action.payload);
          return { ...state, cartCount: action.payload };
        case 'cart/increment':
          const newCount = state.cartCount + 1;
          localStorage.setItem('cartCount', newCount);
          return { ...state, cartCount: newCount };
        case 'cart/clear':
          localStorage.setItem('cartCount', 0);
          return { ...state, cartCount: 0 };
        default:
          return state;
      }
};
export default cartCountReducer;